import React, { Fragment, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import { useToggle } from '../../../../hooks';

const ITEM_KEY = 'hasSeenCoronaVirusNotice';

export default function CoronaVirusNotice({ onMobile }) {
  const { on, toggle, open } = useToggle(false);

  const handleClick = e => {
    e.preventDefault();
    open();
  };

  useEffect(() => {
    const hasSeenNotice = localStorage.getItem(ITEM_KEY);

    if (!hasSeenNotice) {
      open();
    }

    localStorage.setItem(ITEM_KEY, true);
  }, []);

  return (
    <Fragment>
     <p className={`covid-19 ${ onMobile ? 'd-block d-lg-none':'d-none d-lg-block' }`}>Read about HoneyGuide Refund Policy due to Covid-19 <span onClick={handleClick}>here</span>.</p>
     <Modal isOpen={on} toggle={toggle}>
        <ModalHeader>Refund Policy due to Covid-19 (Corona) Virus:</ModalHeader>
        <ModalBody>
          <p>If you’re looking to book transport for other places that aren’t available on the list, please send an enquiry to <a href="mailto:honeyhunter@honeyguideapps.com" target="_blank" rel="noopener noreferrer" style={{color: 'rgb(0, 192, 255)'}}>honeyhunter@honeyguideapps.com</a> or call/whatsapp us at <a href="https://api.whatsapp.com/send?phone=+977-9803759639" target="_blank" rel="noopener noreferrer" style={{color: 'rgb(0, 192, 255)'}}>+977-9803759639</a>
</p>
          <p><button className="btn btn-yellow" onClick={toggle} style={{width: '100%'}}>I understand</button></p>
        </ModalBody>
      </Modal>
    </Fragment>
  );
}
CoronaVirusNotice.defaultProps = {
  onMobile: false,
}





// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/StaticSections/CoronaVirusNotice.js